// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Chat_main__\\+sGTw {
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: hidden;
}
.Chat_blockNotifMessage__JKUJc{
    position: absolute;
    top:0;
    right:0;
    z-index: 2;
    background-color: #3e8f14;
    width: 15px;
    height: 15px;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px;

}

.Chat_texts__gXEw0 {
    flex: 1 1;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    scrollbar-color: #6969dd #e0e0e000;
    scrollbar-width: thin;

    
}
.Chat_containerTool__qoK-M{
    position: fixed;
    bottom:60px;
    right: 0;
    margin:10px;
    z-index: 3;
}

.Chat_blockUser__6aHIw {
    padding: 10px;
    display: flex;
    gap: 10px;
    color: white;
    font-family: Poppins, sans-serif;
    letter-spacing: 1px;
    padding-bottom: 10px;
    font-size: 17px;
    border-bottom: 0.5px rgba(153, 152, 152, 0.5) solid;
}

.Chat_info__pt14c {
    display: flex;
    flex-direction: column;
    white-space: wrap;
}

.Chat_info__pt14c .Chat_head__oxWVN {
    display: flex;
    gap: 5px;
    font-size: 15px;
    font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;
    margin-bottom: 10px;
}

.Chat_text__bF2id {
    white-space: normal;
    word-break: break-word;
    letter-spacing: 1px;
    font-size: 15px;
    font-family: Poppins, sans-serif;
    font-weight: 400;

}

.Chat_chat_input__pdoUu {
    display: flex;
    align-items: center; /* Центрирование контента по вертикали */
    padding: 10px;
}
.Chat_emoji_picker__tCix9 {
    position: absolute;
    bottom: 60px; /* Расположите под текстовым полем */
    right: 0;
    z-index: 1000;
}
.Chat_chat_input__pdoUu textarea {
    flex: 1 1;
    padding: 5px 7px;
    border: none;
    background-color: #22232b;
    color: #eee;
    font-family: Poppins, sans-serif;
    resize: none; /* Отключение изменения размера пользователем */
    border-radius: 5px; /* Сглаживание углов */
    margin-right: 10px; /* Отступ от кнопки */
    min-height: 40px; /* Минимальная высота */
    max-height: 40px; /* Максимальная высота */
    
    
    overflow-y: auto; /* Автоматический вертикальный скролл */
}

.Chat_chat_input__pdoUu .Chat_send__9VVRu {
    padding: 10px; 
    border: none;
    background: #8774e1;
    color: #fff;
    border-radius: 5px;
    cursor: pointer;
    font-size: 16px;
    transition: background 0.3s; /* Плавный переход при наведении */
}

.Chat_chat_input__pdoUu .Chat_send__9VVRu:hover {
    background: #0056b3;
}

@media screen and (max-width: 1000px) {
    .Chat_chat_input__pdoUu {
        padding: 15px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/RightBar/components/Chat/Chat.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,KAAK;IACL,OAAO;IACP,UAAU;IACV,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;;AAEvB;;AAEA;IACI,SAAO;IACP,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,kCAAkC;IAClC,qBAAqB;;;AAGzB;AACA;IACI,eAAe;IACf,WAAW;IACX,QAAQ;IACR,WAAW;IACX,UAAU;AACd;;AAEA;IACI,aAAa;IACb,aAAa;IACb,SAAS;IACT,YAAY;IACZ,gCAAgC;IAChC,mBAAmB;IACnB,oBAAoB;IACpB,eAAe;IACf,mDAAmD;AACvD;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,eAAe;IACf,6EAA6E;IAC7E,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;IACf,gCAAgC;IAChC,gBAAgB;;AAEpB;;AAEA;IACI,aAAa;IACb,mBAAmB,EAAE,wCAAwC;IAC7D,aAAa;AACjB;AACA;IACI,kBAAkB;IAClB,YAAY,EAAE,oCAAoC;IAClD,QAAQ;IACR,aAAa;AACjB;AACA;IACI,SAAO;IACP,gBAAgB;IAChB,YAAY;IACZ,yBAAyB;IACzB,WAAW;IACX,gCAAgC;IAChC,YAAY,EAAE,+CAA+C;IAC7D,kBAAkB,EAAE,sBAAsB;IAC1C,kBAAkB,EAAE,qBAAqB;IACzC,gBAAgB,EAAE,uBAAuB;IACzC,gBAAgB,EAAE,wBAAwB;;;IAG1C,gBAAgB,EAAE,uCAAuC;AAC7D;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,2BAA2B,EAAE,kCAAkC;AACnE;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI;QACI,aAAa;IACjB;AACJ","sourcesContent":[".main {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    overflow: hidden;\n}\n.blockNotifMessage{\n    position: absolute;\n    top:0;\n    right:0;\n    z-index: 2;\n    background-color: #3e8f14;\n    width: 15px;\n    height: 15px;\n    color: white;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 10px;\n\n}\n\n.texts {\n    flex: 1;\n    overflow-y: auto;\n    display: flex;\n    flex-direction: column;\n    scrollbar-color: #6969dd #e0e0e000;\n    scrollbar-width: thin;\n\n    \n}\n.containerTool{\n    position: fixed;\n    bottom:60px;\n    right: 0;\n    margin:10px;\n    z-index: 3;\n}\n\n.blockUser {\n    padding: 10px;\n    display: flex;\n    gap: 10px;\n    color: white;\n    font-family: Poppins, sans-serif;\n    letter-spacing: 1px;\n    padding-bottom: 10px;\n    font-size: 17px;\n    border-bottom: 0.5px rgba(153, 152, 152, 0.5) solid;\n}\n\n.info {\n    display: flex;\n    flex-direction: column;\n    white-space: wrap;\n}\n\n.info .head {\n    display: flex;\n    gap: 5px;\n    font-size: 15px;\n    font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;\n    margin-bottom: 10px;\n}\n\n.text {\n    white-space: normal;\n    word-break: break-word;\n    letter-spacing: 1px;\n    font-size: 15px;\n    font-family: Poppins, sans-serif;\n    font-weight: 400;\n\n}\n\n.chat_input {\n    display: flex;\n    align-items: center; /* Центрирование контента по вертикали */\n    padding: 10px;\n}\n.emoji_picker {\n    position: absolute;\n    bottom: 60px; /* Расположите под текстовым полем */\n    right: 0;\n    z-index: 1000;\n}\n.chat_input textarea {\n    flex: 1;\n    padding: 5px 7px;\n    border: none;\n    background-color: #22232b;\n    color: #eee;\n    font-family: Poppins, sans-serif;\n    resize: none; /* Отключение изменения размера пользователем */\n    border-radius: 5px; /* Сглаживание углов */\n    margin-right: 10px; /* Отступ от кнопки */\n    min-height: 40px; /* Минимальная высота */\n    max-height: 40px; /* Максимальная высота */\n    \n    \n    overflow-y: auto; /* Автоматический вертикальный скролл */\n}\n\n.chat_input .send {\n    padding: 10px; \n    border: none;\n    background: #8774e1;\n    color: #fff;\n    border-radius: 5px;\n    cursor: pointer;\n    font-size: 16px;\n    transition: background 0.3s; /* Плавный переход при наведении */\n}\n\n.chat_input .send:hover {\n    background: #0056b3;\n}\n\n@media screen and (max-width: 1000px) {\n    .chat_input {\n        padding: 15px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `Chat_main__+sGTw`,
	"blockNotifMessage": `Chat_blockNotifMessage__JKUJc`,
	"texts": `Chat_texts__gXEw0`,
	"containerTool": `Chat_containerTool__qoK-M`,
	"blockUser": `Chat_blockUser__6aHIw`,
	"info": `Chat_info__pt14c`,
	"head": `Chat_head__oxWVN`,
	"text": `Chat_text__bF2id`,
	"chat_input": `Chat_chat_input__pdoUu`,
	"emoji_picker": `Chat_emoji_picker__tCix9`,
	"send": `Chat_send__9VVRu`
};
export default ___CSS_LOADER_EXPORT___;
